export default __webpack_public_path__ + "static/media/53.df029def.jpg";